import script from "./CreatePlan.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatePlan.vue?vue&type=script&lang=ts&setup=true"

import "./CreatePlan.vue?vue&type=style&index=0&id=5cce8f34&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cce8f34"]])

export default __exports__